<template>
  <v-container fluid grid-list-md>
    <!-- <v-row>
      <v-col cols="12" justify-center> -->
        <v-container fluid style="padding: 0px;">
          <v-card>
            <v-toolbar elevation="0">
              <v-toolbar-title>Settings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="mx-1" light color="success" @click="saveSiteSettings">Save</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="my-4">
                <v-col cols="4">
                  <v-card-title>Menu Settings</v-card-title>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        label="Worker Label"
                        v-model="settings.workerLabel"
                        :disabled="settings.hideWorkers">
                      </v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-checkbox
                        label="Hide Workers"
                        v-model="settings.hideWorkers">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-text-field
                    label="Item Label"
                    v-model="settings.itemLabel">
                  </v-text-field>
                </v-col>
                <v-col cols="0" md="2">
                </v-col>
                <v-col cols="3">
                  <v-card-title>Field Settings</v-card-title>
                  <v-text-field
                    label="Item Name Label"
                    v-model="settings.itemNameLabel">
                  </v-text-field>
                  <v-text-field
                    label="Item Serial Label"
                    v-model="settings.itemSerialLabel">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card-title>Custom Fields</v-card-title>
                  <v-btn class="mb-4" color="primary" @click="addCustomField">Add Custom Field</v-btn>
                  <v-card v-if="settings.fieldConfig && settings.fieldConfig.customFields && settings.fieldConfig.customFields.length > 0" outlined>
                    <v-list>
                      <v-list-item
                        v-for="(field, index) in settings.fieldConfig.customFields"
                        :key="index"
                        class="px-4">
                        <v-row align="center">
                          <v-col cols="12" md="3">
                            <v-text-field
                              label="Label"
                              v-model="field.label"
                              outlined
                              dense>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select
                              v-model="field.genericField"
                              :items="availableFieldsOptions"
                              label="Generic Field"
                              outlined
                              dense>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="1">
                            <v-btn
                              icon
                              color="error"
                              @click="removeCustomField(index)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-card>
                  <v-alert v-else type="info" outlined class="mt-4">
                    No custom fields configured. Click "Add Custom Field" to create one.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-card-title>Lot Settings</v-card-title>
                    <v-combobox
                      v-model="fetchUICategories"
                      :items="getCategories"
                      item-value="id"
                      item-text="name"
                      label="Parent Categories"
                      @input="handleSettingsCategories"
                      chips
                      multiple
                      deletable-chips>
                    </v-combobox>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    append-icon
                    label="Show Label Header (Thing List)"
                    v-model="swapLotHeaders">
                  <v-icon>mdi-information</v-icon></v-checkbox>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    label="Flatten Events Export"
                    v-model="settings.flattenEventsExports">
                  ></v-checkbox>
                  <v-text-field
                    label="Tag Prefix"
                    v-model="settings.orgTagPrefix">
                  </v-text-field>
                  <v-checkbox
                    label="Prefixed Tag Duplicate Check"
                    v-model="settings.importSettings.prefixedTagDupCheck">
                  </v-checkbox>
                  <v-checkbox
                    label="Generate Prefix Tag"
                    v-model="settings.importSettings.generatePrefixTag">
                  </v-checkbox>
                  <v-checkbox
                    label="Require Zone on import"
                    v-model="settings.importSettings.requireZone">
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      <!-- </v-col>
    </v-row> -->
    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      availableFieldOptions: [],
      tabs: ['UI Settings', 'Import Settings', 'Lot Settings'],
      errorText: '',
      settings: {},
      orgCategories: [],
      parentCategories: [],
      thingHeaders: [],
      swapLotHeaders: false,
      flattenEventsExport: false
    }
  },

  created () {
    // this.fetchUICategories()
  },

  mounted () {
    this.settings = JSON.parse(JSON.stringify(this.siteSettings))
    this.availableFields = JSON.parse(JSON.stringify(this.settings.fieldConfig.availableFields))
    if (this.settings.parentCategories !== null) {
      this.parentCategories = this.settings.parentCategories
    } else {
      this.settings.parentCategories = this.parentCategories
    }
  },

  computed: {
    ...mapGetters([
      'siteSettings',
      'getCategories'
    ]),

    fetchUICategories: function () {
      let categories = []
      this.parentCategories.forEach(c => {
        this.getCategories.find(x => {
          if (x.id === c) {
            categories.push(x)
          }
        })
      })
      return categories
    },

    availableFieldsOptions: function () {
      if (this.settings.fieldConfig && this.settings.fieldConfig.availableFields) {
        return this.settings.fieldConfig.availableFields
      }
      return []
    }
  },

  watch: {
    settings: function () {
      this.enableLabelHeader()
    },

    swapLotHeaders: function () {
      if (this.swapLotHeaders) {
        this.settings.thingHeaders.push('label')
      } else {
        this.settings.thingHeaders = this.settings.thingHeaders.filter(x => x !== 'label')
      }
    }
  },

  methods: {
    ...mapActions([
      'getSiteSettings'
    ]),

    addCustomField: function () {
      if (!this.settings.fieldConfig) {
        this.settings.fieldConfig = {
          availableFields: [],
          customFields: []
        }
      }
      if (!this.settings.fieldConfig.customFields) {
        this.settings.fieldConfig.customFields = []
      }
      this.settings.fieldConfig.customFields.push({
        label: '',
        genericField: '',
        genericType: ''
      })
    },

    removeCustomField: function (index) {
      if (this.settings.fieldConfig && this.settings.fieldConfig.customFields) {
        this.settings.fieldConfig.customFields.splice(index, 1)
      }
    },

    enableLabelHeader: function () {
      if (this.settings.thingHeaders.includes('label')) {
        this.swapLotHeaders = true
      } else {
        this.swapLotHeaders = false
      }
    },

    handleSettingsCategories: function (listItems) {
      this.settings.parentCategories = listItems.map(x => x.id)
    },

    saveSiteSettings: function () {
      ApiRequests.putSiteSettings(this.settings)
      .then(() => {
        this.getSiteSettings()
        this.errorText = 'Saved'
      })
      .catch(e => {
        this.errorText = 'Failed to save: ' + e.response.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SiteSettings.vue